import {
  UseQueryResult,
  useQuery,
} from "@tanstack/react-query";
import { UsersApi } from "../apis/user.apis";

import { BaseQueryOptions } from "types/api.types";
import {
  ApiUser,
} from "types/api-user";

const apiInstance = new UsersApi();

export const useGetMe = (
  options?: BaseQueryOptions<ApiUser, Error, ApiUser, any[]>
): UseQueryResult<ApiUser, Error> => useQuery<ApiUser, Error, ApiUser, any[]>({
  queryKey: [apiInstance.queryKeyName + "-me"],
  queryFn: async () => apiInstance.getMeAsync(),
  ...options,
});